import { useMemo } from 'react';

/**
 * Custom hook to detect if user has unsaved game data that would be lost on navigation.
 * Checks for the three required fields needed to proceed to Step 2 of Share:
 * 1. Moves - Any chess moves in the game
 * 2. Tags - Game tags 
 * 3. Caption - Game description
 * 
 * @param {Array} moves - Array of chess moves
 * @param {Array} tags - Array of game tags
 * @param {string} gameCaption - Game caption/description
 * @returns {boolean} - True if user has unsaved data that would be lost
 */
export const useUnsavedGameData = (moves, tags, gameCaption) => {
  return useMemo(() => {
    const hasMoves = moves?.length > 0;
    const hasTags = tags?.length > 0;
    const hasCaption = gameCaption?.trim().length > 0;
    
    return hasMoves || hasTags || hasCaption;
  }, [moves, tags, gameCaption]);
};

export default useUnsavedGameData;